module.exports = __webpack_public_path__ + "files/c39db207b534dc7ba887ff1246fe316a.png";